import React from "react";
import strings from "../helpers/Localization";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export default class Error extends React.Component {
    render() {
        return (
            <Grid container alignItems="center" justify="center" style={{ height: "100vh", backgroundColor: "#fafafa" }}>
                <Grid xs={9} item>
                    <Paper className="defaultPagePaper">
                        <div style={{ marginTop: "20px", textAlign: "center", width: "100%" }}>
                            <Typography variant="h6" style={{ paddingTop: "40px" }} gutterBottom>
                                {strings.unexpectedError}
                            </Typography>
                            <Typography variant="subtitle1" style={{ marginBottom: "20px" }}>
                                {strings.unexpectedErrorDescription}
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                // onClick={() => window.location.href = "/"}
                                onClick={() => location.reload(true)}
                            >
                                {strings.refreshPage}
                            </Button>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}
